import React from 'react';
import classnames from 'classnames';
import styles from './SiteLinks.module.scss';
import GutterBag, { GutterBagProps } from '../../GutterBag/GutterBag';
import SiteLink, { TopBarItemShape } from '../SiteLink/SiteLink';
import { LinkAdapter } from '../../Link/Link';

type SiteLinksProps = {
  /** SiteLink links */
  links: TopBarItemShape[];
  /** Force desktop styles for the sitelinks in mobile */
  desktopStylesInMobile?: boolean;
  /** Class name */
  className?: string;
  /** Custom Link component */
  linkAdapter?: LinkAdapter;
} & GutterBagProps;
const SiteLinks: React.FunctionComponent<SiteLinksProps> = ({
  links,
  desktopStylesInMobile,
  className,
  linkAdapter,
  ...props
}) => {
  return (
    <GutterBag
      showOverflow={true}
      data-testid="site-links"
      className={classnames(
        [styles.siteLinks],
        { [styles.siteLinks__forceDesktop]: desktopStylesInMobile },
        className
      )}
      contents={links.map((link) => (
        <SiteLink key={link.text} link={link} linkAdapter={linkAdapter} />
      ))}
      spacing={{ horizontal: 'sm', vertical: 'zero' }}
      {...props}
    />
  );
};

export default SiteLinks;
